import { IRootState } from '../reducer'
import { prefix } from './actions'

export const flags = (state: IRootState) => state[prefix].flags

export const lastListContext = (state: IRootState) => state[prefix].lastListContext

export const flagDetails = (state: IRootState) => state[prefix].flagDetails

export const isLoading = (state: IRootState) => state[prefix].isLoading

export const newFlagsCount = (state: IRootState) => state[prefix].newFlagsCount

export const flagOptions = (state: IRootState) => state[prefix].flagOptions

export const summaryMetrics = (state: IRootState) => state[prefix].summaryMetrics
